import React from "react";

/**
 * App-root safety net.
 * Any uncaught render error shows a friendly panel with a reload button
 * instead of the raw React overlay / white screen.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-[#F9F9F8] grid place-items-center p-6" data-testid="app-error-boundary">
        <div className="w-full max-w-md bg-white border border-[#E2E4E0] rounded-lg p-8 text-center">
          <div className="w-12 h-12 rounded-full bg-[#FDF3F3] text-[#C94A4A] grid place-items-center mx-auto mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>
          <h1 className="db-h text-lg font-bold text-[#1A1D1A]">Something went wrong</h1>
          <p className="text-sm text-[#5C665A] mt-1">
            The page hit an unexpected error. Please reload — if it happens again, let the team know.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            data-testid="app-error-reload"
            className="mt-5 inline-flex items-center justify-center h-10 px-4 rounded-md bg-[#2D6A4F] hover:bg-[#1B4332] text-white text-sm active:scale-95 transition"
          >
            Reload page
          </button>
        </div>
      </div>
    );
  }
}
